<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    :width="width"
    :height="height"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0,512) scale(0.1,-0.1)" fill="#BFBFBF" stroke="none">
      <path
        d="M442 5100 c-106 -28 -187 -75 -267 -155 -81 -81 -127 -161 -155 -271 -20 -76 -20 -118 -20 -2114 0 -1996 0 -2038 20 -2114 28 -110 74 -190 155 -271 81 -81 161 -127 271 -155 76 -20 118 -20 2114 -20 1996 0 2038 0 2114 20 43 11 105 34 139 52 87 45 194 156 240 246 72 145 68 20 65 1957 -3 1658 -4 1743 -22 1805 -23 80 -83 212 -126 277 -45 66 -521 545 -597 599 -72 52 -202 114 -293 140 -62 18 -146 19 -1815 21 -1698 2 -1752 2 -1823 -17z m2895 -646 c15 -11 38 -36 51 -54 23 -34 23 -35 20 -355 -3 -313 -4 -321 -25 -351 -49 -68 33 -64 -1256 -64 l-1164 0 -34 23 c-19 12 -44 42 -57 67 -22 44 -23 49 -20 345 3 282 4 302 24 335 11 19 38 45 60 57 l39 23 1167 -3 c1166 -2 1167 -2 1195 -23z m-513 -1718 c632 -189 893 -921 526 -1467 -58 -86 -174 -199 -265 -258 -270 -176 -626 -205 -917 -73 -154 70 -308 198 -398 331 -356 529 -125 1234 475 1450 116 42 181 51 340 47 127 -3 164 -7 239 -30z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
